<template>
  <v-navigation-drawer width="400" v-model="localDrawer" right temporary app>
    <v-list-item :class="localAula.color">
      <v-list-item-content>
        <v-list-item-title class="font-weight-medium">{{
          localAula.tipo_de_aula
        }}</v-list-item-title>
      </v-list-item-content>
    </v-list-item>
    <v-divider></v-divider>
    <v-list-item>
      <v-list-item-content>
        <div class="mt-2">
          <v-list-item-title>Professor (a)</v-list-item-title>
          <p class="font-weight-light text-justify">
            {{ localAula.professor?.nome }}
          </p>
        </div>
        <v-divider></v-divider>
        <div class="mt-2">
          {{ localAula.isInfantil }}
          <v-list-item-title>Data</v-list-item-title>
          <p class="font-weight-light text-justify" v-if="localAula.is_polivalencia">
            {{ localAula.data_formatada }}
            {{ " - " }}
            {{ localAula.horarios_formatted }}
          </p>
          <p class="font-weight-light text-justify" v-else>
            {{ localAula.data_formatada }}
            {{ " - " }}
            {{ localAula.horario ? localAula.horario.descricao : "[- - -]" }}
          </p>
        </div>
        <template v-if="localAula.turma?.curso_id === 5">
          <div class="mt-4 mb-5">
            <v-list-item-title>Série(s)</v-list-item-title>
          </div>
          <div v-if="localAula.series_extras">
            <p
              v-for="(serie, index) in JSON.parse(localAula.series_extras)"
              :key="index"
              class="font-weight-light text-justify"
            >
              {{ series.find((d) => d.id === serie.array[0]).descricao }}
            </p>
          </div>
          <div v-else>
            <p
              v-for="(serie, index) in localAula.series"
              :key="index"
              class="font-weight-light text-justify"
            >
              {{ getDescricaoSerie(serie) }}
            </p>
          </div>
        </template>
        <!-- <template v-if="localAula.disciplina">
          <div class="mt-4 mb-0">
            <v-list-item-title>
              <strong> Disciplina:</strong>
              {{ localAula.disciplina ? localAula.disciplina.descricao : "[- - -]" }}
            </v-list-item-title>
          </div>
        </template> -->
        <template v-if="localAula.disciplinas_com_descricao != ''">
          <div class="mt-4 mb-5">
            <v-list-item-title>Disciplina(s)</v-list-item-title>
          </div>
          <div>
            <div v-for="(disciplinaId, index) in localAula.disciplinas" :key="disciplinaId">
              <div class="mt-4 mb-4">
                <span class="font-weight-bold text-uppercase">
                  {{
                    localAula.disciplinas_com_descricao.find((d) => d.id === disciplinaId)
                      ?.descricao || "- - -"
                  }}
                </span>
              </div>
              <div class="mt-4 mb-5">
                <span>Conteúdo: </span>
                <span
                  v-if="localAula.conteudo_polivalencia"
                  v-html="
                    JSON.parse(localAula.conteudo_polivalencia)[index]
                      ? JSON.parse(localAula.conteudo_polivalencia)[index].replace(/:\s*$/, '') +
                        '.'
                      : '- - -'
                  "
                  class="font-weight-light text-justify"
                ></span>
              </div>
            </div>
          </div>
        </template>
        <!-- {{ localAula }} -->
        <div v-for="(item, index) of $constants.listCamposAulasLancadas" :key="index">
          <div v-if="index !== 'campos_de_experiencias'">
            <v-list-item-title v-if="localAula[index]" class="mt-4">{{ item }}</v-list-item-title>
            <div v-if="localAula[index]" class="font-weight-light text-justify">
              <div
                v-html="formatTexto(localAula[index]) ? formatTexto(localAula[index]) : '- - -'"
              ></div>
            </div>
          </div>
          <div v-else>
            <v-list-item-title
              v-if="localAula[index] && localAula.campos_de_experiencias.length"
              class="mt-4 mb-2"
              >{{ item }}</v-list-item-title
            >
            <div v-for="(el, index) of localAula[index]" :key="index">
              <p v-if="el" :key="index" class="font-weight-light text-justify">•{{ el }}</p>
            </div>
          </div>
        </div>
        <v-divider></v-divider>
        <!-- <v-list-item-title class="mt-4">Metodología</v-list-item-title>
        <p class="font-weight-light text-justify">
          {{ localAula.metodologia }}
        </p> -->
        <v-divider></v-divider>
        <v-list-item-title class="mt-4">Situação</v-list-item-title>
        <v-list-item-title>
          <v-chip label :color="localAula.color">
            {{ localAula.descricaoSituacao }}
          </v-chip>
        </v-list-item-title>
        <v-list-item-title class="mt-4">Motivo</v-list-item-title>
        <p class="font-weight-light">
          {{ localAula.motivo ? localAula.motivo : "Sem motivo." }}
        </p>
      </v-list-item-content>
    </v-list-item>
  </v-navigation-drawer>
</template>

<script>
export default {
  props: {
    value: {
      type: Boolean,
      required: true,
    },
    aula: {
      type: Object,
      required: true,
    },
    disciplina: {
      type: Object,
      required: false,
    },
  },
  methods: {
    getDescricaoSerie(id) {
      return this.aula.turma.series.filter((obj) => obj.id === id)[0].descricao;
    },
    formatTexto(texto) {
      const textoSemColchetes = texto.replace(/\[|\]/g, ""); // Remover colchetes
      const textoSemQuebraDeLinha = textoSemColchetes.replace(/\\n/g, " ").replace(/"/g, ""); // Remover caracteres de nova linha (\n) e aspas
      const textoFormatado = textoSemQuebraDeLinha.replace(/\n/g, "<br>"); // Substituir quebras de linha por HTML <br>
      return textoFormatado.trim() || "- - -";
    },
    async disciplinasAll() {
      const disciplinas = await this.$services.disciplinasService.syncAll();
      this.disciplinas = disciplinas;
    },
    async seriesAll() {
      const series = await this.$services.seriesService.syncAll();
      this.series = series;
    },
  },
  mounted() {
    this.disciplinasAll();
    this.seriesAll();
  },
  watch: {
    value() {
      this.localDrawer = this.value;
    },
    localDrawer() {
      this.$emit("input", this.localDrawer);
    },
  },
  computed: {
    localAula() {
      return this.aula;
    },
  },
  data() {
    return {
      localDrawer: this.value,
      disciplinas: [],
      series: [],
    };
  },
};
</script>

<style lang="scss" scoped></style>
